import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/PTZ/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SetPtzPerm';
import PTZTable01 from 'components/Web_User_Interface/1440p_Series/Features/PTZ/ptz01Table';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Features Menü // Pan, Tilt & Zoom",
  "path": "/Web_User_Interface/1440p_Serie/Features/PTZ/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Lassen Sie Ihre Kamera nach dem Neustart auf eine gespeicherte Position fahren oder limitieren Sie die Dreh- und Schwenkbewegung.",
  "image": "./WebUI_1440p_SearchThumb_Features_PTZ.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Features_PTZ.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Features Menü // Pan, Tilt & Zoom' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Lassen Sie Ihre Kamera nach dem Neustart auf eine gespeicherte Position fahren oder limitieren Sie die Dreh- und Schwenkbewegung.' image='/images/Search/WebUI_1440p_SearchThumb_Features_PTZ.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Features_PTZ.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Features/PTZ/' locationFR='/fr/Web_User_Interface/1440p_Series/Features/PTZ/' crumbLabel="Pan, Tilt & Zoom" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "features-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#features-men%C3%BC",
        "aria-label": "features menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "pan--tilt-funktion",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#pan--tilt-funktion",
        "aria-label": "pan  tilt funktion permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Pan & Tilt Funktion`}</h2>
    <p><em parentName="p">{`nur PTZ Kameras`}</em></p>
    <h3 {...{
      "id": "positionen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#positionen",
        "aria-label": "positionen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Positionen`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/1318829b41121883d762d8fa91078b87/abe2a/1440p_Settings_Features_PTZ_Settings.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.52173913043479%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACFklEQVQoz22T3U4TURRG+xYmNaHR2MZpS0mJ2tL2zF8HgWrbOfPXGaaOKRIgBKNIqcEbownEKxN9AG+Ve95vmRkoEPRiZZ+rlW/vfXauVqtRrVapLtZ4XHyAFk6xP1+wfvybjdk51vQP1tENq9NzBifneF8uaI+OEe0G1cVF8vk8hUKBXLlcJqNSofjoIeYwIT76zujtGeG7b/gHZ3h3GB2cEh//ZCPcp9VcofGsxVJtmXr9CblKpcKcYqmEJlqE7gDffoE37CFfrv2D3bOwRwmDoY8mLFTRxdBXER2DnKIozFMWi0V0w2A8ToiiTcJoE8/zkY6Lc0X6dl2PrZ09PLnJencd0zBQhUm7pV4K03TXQl0niiKCIMD3fRzHQUqZ1fnbdV0mkwmvo4Akek7X1BAdk3Zbu0mYSkulUiYcj8fX0rnsbk2SLSZJn0ksMHUdXTUQHfX/wlSWpku5nW6O6zqE8StmewkHcQ9VCNa6OqpQb7acLeWq5bsJL3GQVwk9xyGKY04PP/Bjf0Kn06KrG5cznG/49gzDMMzSeZ6HlDZ+EOA5Nq7dx3FshkFAT0pOZlN+zbaRGxqqaiI6+r9CwzCuW04Ter5POAoYJbsEOzPGyS6HUvLe9fEHfczGEk/rVRSlgqKUb33scjmbYbPZxLKsTJxhmhiaiinfYG59pW9v87HR5JMwWKkvcy9/n4WFQnYl6aX8BRiBlwfAYz9fAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/1318829b41121883d762d8fa91078b87/e4706/1440p_Settings_Features_PTZ_Settings.avif 230w", "/de/static/1318829b41121883d762d8fa91078b87/d1af7/1440p_Settings_Features_PTZ_Settings.avif 460w", "/de/static/1318829b41121883d762d8fa91078b87/7f308/1440p_Settings_Features_PTZ_Settings.avif 920w", "/de/static/1318829b41121883d762d8fa91078b87/85e95/1440p_Settings_Features_PTZ_Settings.avif 1067w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/1318829b41121883d762d8fa91078b87/a0b58/1440p_Settings_Features_PTZ_Settings.webp 230w", "/de/static/1318829b41121883d762d8fa91078b87/bc10c/1440p_Settings_Features_PTZ_Settings.webp 460w", "/de/static/1318829b41121883d762d8fa91078b87/966d8/1440p_Settings_Features_PTZ_Settings.webp 920w", "/de/static/1318829b41121883d762d8fa91078b87/d7218/1440p_Settings_Features_PTZ_Settings.webp 1067w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/1318829b41121883d762d8fa91078b87/81c8e/1440p_Settings_Features_PTZ_Settings.png 230w", "/de/static/1318829b41121883d762d8fa91078b87/08a84/1440p_Settings_Features_PTZ_Settings.png 460w", "/de/static/1318829b41121883d762d8fa91078b87/c0255/1440p_Settings_Features_PTZ_Settings.png 920w", "/de/static/1318829b41121883d762d8fa91078b87/abe2a/1440p_Settings_Features_PTZ_Settings.png 1067w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/1318829b41121883d762d8fa91078b87/c0255/1440p_Settings_Features_PTZ_Settings.png",
              "alt": "Web User Interface - 1440p Series - Features PTZ",
              "title": "Web User Interface - 1440p Series - Features PTZ",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <PTZTable01 mdxType="PTZTable01" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{` Hier können Sie die Justagefahrt beim Kamerastart deaktivieren (beachten Sie bitte, dass dies auch die speicherbaren Funktionen deaktiviert!), legen Sie fest, dass die Kamera, anstatt der Mittelposition, die gespeicherte Position 1 nach einem Neustart (oder bei einer Alarmauslösung) anfährt und bestimmen Sie wie viele vertikale und horizontale Fahrten die Kamera durchführt, wenn Sie den `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Live_Video/"
      }}>{`HSCAN oder VSCAN`}</a>{` aktivieren.`}</p>
    <p>{`Die Pan & Tilt Limits werden neben dem `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Live_Video/"
      }}>{`PTZ Control Pad angezeigt`}</a>{`. Sie können damit den Bewegungsbereich Ihrer Kamera begrenzen (siehe unten).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      